<div class="virtual-grid-settings flex flex--row flex--space-between flex--nowrap text-16 u-mv---">
  <div class="information">
    <virtual-grid-card-sort
      *ngIf="!hideFilter"
      [layout]="worklistColumnMetaData"
      [include]="columnFilterInclude"
      [disabledColumns]="disabledSortColumns"
      [sortCriteria]="sortCriteria"
      [enableResetSortButton]="enableResetSortButton"
      (sortCriteriaChange)="sortCriteriaChange.emit($event)"
      (resetSort)="resetSort.emit()"
    >
      <ng-content select="[slot=sort]"></ng-content>
    </virtual-grid-card-sort>
  </div>

  <div class="flex flex--middle u-pr---">
    <div *ngIf="!hideFilter" class="clickable">
      <wfm-dropdown defaultPosition="right" [(isOpen)]="isFilterOpen">
        <span slot="trigger" class="icon">
          <wfm-badge
            [icon]="'ico-' + filterIcon + '-16'"
            size="small"
            color="currentColor"
            badgeStyle="informational"
            type="notification"
            [count]="filterCriteria?.length"
          >
          </wfm-badge>
        </span>

        <virtual-grid-card-filter
          class="flex"
          [isActive]="isFilterOpen"
          [layout]="worklistColumnMetaData"
          [include]="columnFilterInclude"
          [filterCriteria]="filterCriteria"
          (closeRequest)="isFilterOpen = false"
          (filterCriteriaChange)="filterCriteriaChange.emit($event)"
        >
        </virtual-grid-card-filter>
      </wfm-dropdown>
    </div>

    <wfm-dropdown
      defaultPosition="right"
      [(isOpen)]="templateMenuOpen"
      [disabled]="disabled"
      *ngIf="!disableTemplateManagement"
    >
      <div
        slot="trigger"
        class="line-height-100 clickable"
        [ngClass]="{ 'settings-disable': disabled }"
        style="overflow-y: hidden"
        [disableTooltip]="templateMenuOpen"
        [tooltip]="'vg.manageTemplates' | translate"
        position="left"
      >
        <svg-icon
          name="ico-viewportsettings-16"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
        ></svg-icon>
      </div>

      <ul class="menu__panel menu__panel--right template--menu text-16" [attr.aria-hidden]="!templateMenuOpen">
        <div>
          <li class="menu__item no-hover">{{ 'vgl.layouts' | translate }}</li>
          <div
            wfmScrollbar
            style="
              justify-content: unset;
              max-height: 450px;
              width: 100%;
              overflow-x: hidden;
              overflow-y: auto;
              margin: 0%;
              padding: 0%;
            "
          >
            <li class="menu__item-wrap" *ngFor="let template of templates | orderBy: '+templateName'">
              <div
                *ngIf="template.flags != 7"
                class="menu__item flex flex--row flex--nowrap"
                [class.selected]="template.templateId === launchTemplate?.templateId"
              >
                <span
                  class="flex--item--zero text-ellipsis"
                  (click)="selectTemplate(template)"
                >
                  <div
                    #refEl
                    class="text-ellipsis"
                    (mouseenter)="isTextTruncated(refEl)"
                    [tooltip]="toolTip"
                    [delay]="800"
                  >
                    <svg-icon
                      [hidden]="template.isGlobalTemplate"
                      name="ico-user-16"
                      [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
                    ></svg-icon>
                    <svg-icon
                      [hidden]="!template.isGlobalTemplate"
                      name="ico-group-16"
                      [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
                    ></svg-icon>

                    {{ template.templateName }}
                  </div>
                </span>
              </div>
            </li>
          </div>
          <li class="menu__item-wrap">
            <div class="menu__item-divider"></div>
            <div class="menu__item flex flex--row flex--nowrap manage-template">
              <span class="flex--item--zero text-ellipsis" (click)="manageTemplates()">
                {{ 'vgl.manageMyTemplates' | translate }}
              </span>
            </div>
          </li>
          <li *ngIf="isAdmin" class="menu__item-wrap">
            <div class="menu__item-divider"></div>
            <div class="menu__item flex flex--row flex--nowrap manage-template">
              <span class="flex--item--zero text-ellipsis" (click)="editCommonTemplate()">
                {{ 'vgl.manageCommonTemplates' | translate }}
              </span>
            </div>
          </li>
        </div>
      </ul>
    </wfm-dropdown>
  </div>

  <ng-template #settingsTemplate>
    <virtual-grid-layout
      [worklistColumnMetaData]="worklistColumnMetaData"
      [managementWorklists]="managementWorklists"
      [templates]="templates"
      [selectedTemplate]="launchTemplate"
      [admin]="adminAccess"
      [(activeTab)]="editorTab"
      (worklistColumnMetaDataChange)="saveColumnMetaData($event)"
      (selectedTemplateChange)="templateselected($event)"
      (createNewTemplateEvent)="createNewLayout($event)"
      (worklistMetaSave)="worklistMetaSaveFromLayout($event)"
      (applyTemplateToWorklistsEvent)="applyTemplateToWorklistsEvent($event)"
      (applyDefaultTemplateToWorklistsEvent)="applyDefaultTemplateToWorklistsEvent($event)"
      (applyWithoutSaveAndClose)="applyWithoutSaveAndClose($event)"
    >
    </virtual-grid-layout>
  </ng-template>
</div>
